import React from 'react';

import Select from 'react-select';
import { Props as SelectProps } from 'react-select/lib/Select';

import { PX } from '../../contrib/ui';
import { selectorTheme } from '../../contrib/utils';

export const AutoComplete = (props: SelectProps) => {
  const { title, outlined, className, isClearable, isDisabled } = props;

  return (
    <div className="autocomplete-wrapper">
      {!!title && !!outlined && (
        <div className="autocomplete-title">
          <span>{title}</span>
          <div className="angle" />
          <div className="angle2" />
        </div>
      )}
      <Select
        {...props}
        className={`autocomplete ${className || ''} ${outlined ? 'outlined' : ''} ${
          outlined && title ? 'has-title' : ''
        } `}
        maxMenuHeight={180 * PX}
        classNamePrefix="autocomplete"
        theme={selectorTheme}
        isClearable={isClearable}
        isDisabled={isDisabled}
      />
    </div>
  );
};
